<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="600px" transition="dialog-transition">
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <v-toolbar-title>Datos de Factura.</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="py-2" v-if="factura && matriz" id="factura_html">
          <div class="w-100">
            <!-- <img v-if="UNIDAD_NEGOCIO_ID === 1" src="/img/Picture2.png" class="watermark2" alt="watermark2" />
            <img v-if="UNIDAD_NEGOCIO_ID === 1" src="/img/Picture1.png" class="watermark1" alt="watermark1" />
             -->
            <br />
            <table class="item-table mb-2">
              <tr class="">
                <td rowspan="4" class="w-38per align-v-center">
                  <img
                    v-if="factura.nit_empresa != 4265269017"
                    src="/img/logo_esam_factura.png"
                    alt="esam"
                    height=""
                    class="img-height float-left"
                  />
                  <div class="align-v-center px-2 recibo-number">
                    {{ nit.nombre }}<br />
                    {{ matriz.direccion }} <br />
                    {{ matriz.ciudad }} <br />
                    Teléfono: {{ matriz.telefono }}
                  </div>
                </td>

                <td rowspan="4" class="w-24per text-center align-v-center pa-2">
                  <div class="recibo-number border-box">
                    <span>
                      FACTURA <br />
                      ORIGINAL
                    </span>
                  </div>
                </td>
                <td class="text-right"><strong>NIT</strong></td>
                <td class="text-right recibo-number font-size-1">{{ factura.nit_empresa }}</td>
              </tr>
              <tr class="x-small">
                <td class="text-right"><strong>FACTURA N°</strong></td>
                <td class="text-right recibo-number">{{ factura.numero_factura }}</td>
              </tr>
              <tr class="x-small">
                <td class="text-right"><strong>AUTORIZACIÓN</strong></td>
                <td class="text-right recibo-number">{{ factura.numero_autorizacion }}</td>
              </tr>
              <tr class="x-small">
                <td class="text-right recibo-number" colspan="2">{{ `${factura.actividad}`.toUpperCase() }}</td>
              </tr>

              <tr class="x-small" v-if="sucursal && sucursal.numero_sucursal">
                <td colspan="4" class="">
                  <span>
                    SUCURSAL N° {{ sucursal.numero_sucursal }}, {{ sucursal.direccion }}<br />
                    {{ sucursal.ciudad }} <br />
                    Teléfono: {{ sucursal.telefono }}
                  </span>
                </td>
              </tr>
            </table>

            <table class="item-table mb-2">
              <tr>
                <td colspan="2" class=""><strong>Fecha: </strong> {{ factura.fecha }}</td>
                <td colspan="2" class=""><strong>NIT/CI: </strong>{{ factura.nit_cliente }}</td>
              </tr>
              <tr>
                <td colspan="5" class=""><strong>Señor(es): </strong>{{ factura.nombre_cliente }}</td>
              </tr>
            </table>

            <table class="item-table table-border">
              <thead>
                <th class="item-th text-left pl-1 w-10per">Código</th>
                <th class="item-th text-left">Descripción</th>
                <th class="item-th text-center w-10per">Cantidad</th>
                <th class="item-th text-right w-10per">Precio</th>
                <th class="item-th text-right w-10per">TOTAL</th>
              </thead>
              <tbody class="">
                <tr>
                  <td class="pl-1">
                    <strong>{{ programa ? programa.codigo : '000' }} </strong>
                  </td>
                  <td class="">
                    {{
                      `${programa.nombre_compuesto}`.length > 160
                        ? `${programa.nombre_compuesto.slice(0, 160)}...`
                        : programa.nombre_compuesto
                    }}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="item-tr" v-for="(item, index) in factura.detalle" :key="index">
                  <td class="item-td text-left"></td>
                  <td class="item-td text-left">{{ item.concepto }}</td>
                  <td class="item-td text-center">1</td>
                  <td class="item-td text-right">{{ numeralFormat(item.monto) }}</td>
                  <td class="item-td text-right">{{ numeralFormat(item.monto) }}</td>
                </tr>
                <tr class="item-tr">
                  <td :colspan="4" class="text-right">Subtotal Bs.</td>
                  <td class="item-td text-right recibo-number">{{ numeralFormat(subtotal) }}</td>
                </tr>
                <tr class="item-tr">
                  <td :colspan="4" class="text-right">Descuento Bs.</td>
                  <td class="item-td text-right recibo-number">{{ numeralFormat() }}</td>
                </tr>
                <tr class="item-tr">
                  <td :colspan="4" class="text-right">Total Bs.</td>
                  <td class="item-td text-right recibo-number">{{ numeralFormat(factura.monto) }}</td>
                </tr>

                <tr class="item-tr">
                  <td :colspan="5" class="text-right">
                    <span class="font-weight-bold">
                      SON {{ literal.toUpperCase() }} <strong> 00/100 BOLIVIANOS</strong>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="item-table">
              <tr v-if="factura">
                <td class="w-20per"><vue-qrcode :value="factura.qr" :errorCorrectionLevel="level" :scale="size" /></td>
                <td colspan="3">
                  <strong class="r-box r-title2">Código de Control: </strong>
                  <span class="r-box r-text"> {{ factura.codigo_control }} </span>
                  <br />
                  <strong class="r-box r-title2">Fecha Límite de Emisión: </strong>
                  <span class="r-box r-text"> {{ formatDate(factura.fecha_limite_emision) }} </span> <br />
                  {{ factura.primera_linea }} <br />
                  {{ factura.segunda_linea }}
                </td>
              </tr>
            </table>
          </div>
          <!-- ============== -->
          <div class="w-98per mitad-solid d-none"></div>
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-card-actions v-if="factura && matriz">
          <v-btn :disabled="$store.state.isonlyread" color="primary" v-if="factura.impreso" small rounded @click="printRecibo">
            <v-icon class="mr-1"> mdi-printer</v-icon> Imprimir
          </v-btn>
          <!-- <v-btn color="red" dark v-if="puedeAnular" small rounded @click="anularFactura">
            <v-icon class="mr-1"> mdi-file-cancel</v-icon> Anular Factura
          </v-btn> -->
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined small rounded @click="closeDialog">
            Cancelar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-skeleton-loader v-else transition="scale-transition" height="290" type="table"> </v-skeleton-loader>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  // https://www.learmoreseekmore.com/2020/10/vuejs-vueqrcode.html
  import VueQrcode from 'vue-qrcode';
  import xaxios from '@/xaxios';
  import { Printd } from 'printd';
  import gql from 'graphql-tag';
  import moment from 'moment';
  import numeral from 'numeral';
  import { mapState } from 'vuex';

  moment.locale('es');

  export default {
    components: { VueQrcode },
    props: ['programa_id'],
    data() {
      return {
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        cssText: null,

        size: 1.6,
        level: 'H',
        dialog: false,
        recibo: null,
        factura: null,
        subtotal: 0.0,
        programa: null,
        today: new Date().toISOString(),
        matriz: null,
        sucursal: null,
        nit: null,
        literal: null,
        estado: true,
      };
    },
    computed: {
      /*puedeAnular() {
        if (this.factura) {
          if (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14) {
            return (
              this.factura.fecha_registro.substr(0, 7) === this.today.substr(0, 7) && this.factura.estado === 'VALIDA'
            );
          }
        }
        return false;
      },*/
      puedeAnular() {
        if (this.factura) {
          if (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14) {
            let emitido = this.factura.fecha_registro;
            let hoy = this.today;
            try {
              let fs1 = emitido.split(' ')[0].split('-');
              let fs2 = hoy.split('-');
              let date1 = new Date();
              let date2 = new Date();
              date1.setFullYear(fs1[0]);
              date1.setMonth(fs1[1] - 1);
              date1.setDate(fs1[2]);
              date2.setFullYear(fs2[0]);
              date2.setMonth(fs2[1] - 1);
              date2.setDate(fs2[2]);

              let mes1 = date1.getMonth();
              let mes2 = date2.getMonth();
              let dia2 = date2.getDate();
              let diferencia = mes2 - mes1;

              // diferencia es que estamos en el mismo mes
              // diferencia 1 es que ya paso un mes
              // el dia debe ser menor o igual a 4 dias pasados 1 mes
              if (diferencia == 0) {
                return true;
              } else if (diferencia == 1 && dia2 <= 4) {
                return true;
              }
              return false;
            } catch (e) {
              window.console.error(e);
              return false;
            }
          }
        }
        return false;
      },
      ...mapState({
        sede_id: (state) => state.CARGO.sede.id,
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      }),
    },
    watch: {
      programa_id(id) {
        if (id)
        xaxios.get(`${this.api_rest}/esam/programa/id/${id}`).then(({ data }) => {
            this.programa = data;
          });
      },
    },
    methods: {
      async showThisView(factura_id, recibo) {
        this.dialog = true;
        this.recibo = recibo;
        this.factura = await this.getFacturaData(factura_id);
        window.console.log('>>>', this.factura,factura_id);
        this.factura.fecha = moment(this.factura.fecha).format('DD MMMM [del] YYYY');
        this.getSucursales(this.factura.nit_empresa, await this.getNits(), this.factura.sucursal_id);
      },
      getSucursales(nro_nit, nits, sucursal_id) {
        const qs = gql`query{ ${''} getSucursales{ id,nit_id,direccion,telefono,ciudad,numero_sucursal } }`;
        this.$apollo.query({ query: qs }).then(({ data }) => {
          let sucursales = data.getSucursales ? data.getSucursales : [];
          window.console.log('>>>: ',sucursales);
          if (data.getSucursales.length) {
            this.nit = nits.find((ni) => ni.nro == nro_nit);
            sucursales = sucursales.filter((s) => s.nit_id === this.nit.id);
            this.matriz = sucursales.find((s) => s.numero_sucursal === 0);
            this.sucursal = sucursales.find((s) => s.id === sucursal_id);
          }
        });
      },
      getNits() {
        const qs = gql`query{ ${''} getNits{ id, nombre, descripcion, nro, estado }}`;
        return this.$apollo.query({ query: qs }).then(({ data }) => (data.getNits ? data.getNits : []));
      },

      async getFacturaData(factura_id) {
        const url = `${this.api_rest}/api/pagos/factura/id/${factura_id}`;
        const writtenNumber = require('written-number');
        const res = await xaxios.get(url).then(({data})=>data).catch(() => null)
        
        if(!this.programa) this.programa = {};


        const data = res
        this.subtotal = 0.0;
            data.detalle.map((item) => {
              item.concepto_name = `${item.concepto}, ${this.programa.nombre_compuesto}`;
              return item;
            });
            data.detalle.forEach((item) => (this.subtotal += item.monto));
            //this.literal = writtenNumber(data.monto, { lang: 'es' });
            let lit = writtenNumber(data.monto, { lang: 'es' });
            if (lit.endsWith('ciento')) {
              lit = lit.replace('ciento', 'cien');
            }
            this.literal = lit;
            return data;
        
        /*return await xaxios
          .get(url)
          .then(({ data }) => {
            this.subtotal = 0.0;
            data.detalle.map((item) => {
              item.concepto_name = `${item.concepto}, ${this.programa.nombre_compuesto}`;
              return item;
            });
            data.detalle.forEach((item) => (this.subtotal += item.monto));
            //this.literal = writtenNumber(data.monto, { lang: 'es' });
            let lit = writtenNumber(data.monto, { lang: 'es' });
            if (lit.endsWith('ciento')) {
              lit = lit.replace('ciento', 'cien');
            }
            this.literal = lit;
            return data;
          })
          .catch(() => null);*/
      },


      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.slice(0, 10).split('-');
        return `${day}/${month}/${year}`;
      },
      async anularFactura() {
        window.console.log('PUEDE>>> ',this.puedeAnular);
        if (this.puedeAnular) {
        //if (this.factura.fecha_registro.substr(0, 7) === this.today.substr(0, 7)) {
          if (
            await this.$root.$confirm.open(
              'Anular Factura',
              '<strong> Esta accion es irreversible. <br /> Estas seguro?</strong> ',
              { color: 'red' },
            )
          ) {
            xaxios.delete(`${this.api_rest}/api/pagos/factura/id/${this.factura.id}`).then((res) => {
              this.$root.$notify.show(res.status === 200 ? 'Factura Anulada' : 'No se puede anular la Factura', {
                color: 'info',
              });
              this.$emit('fanulada');
            });
            this.closeDialog();
          }
        }
      },
      numeralFormat(value) {
        return numeral(value).format('0,0.00');
      },
      printRecibo() {
        const d = new Printd();
        const scripts = [];
        const el = document.getElementById('factura_html');
        const styles = [this.cssText, 'https://fonts.googleapis.com/css?family=Roboto'];

        const printCallback = ({ launchPrint, iframe }) => {
          const { contentWindow } = iframe;
          contentWindow.addEventListener('afterprint', () => {
            // window.console.log('after print!', JSON.stringify(event), `{id: ${this.factura.id},allow_print:${this.estado}}`);
            // this.$apollo
            //   .mutate({ mutation: gql`mutation{changeFacturaPrint(input:{id: ${this.factura.id},allow_print:${this.estado}}){ ok, factura{ id estado, impreso}}}` })
            //   .then(({ data }) => { data.ok ? this.$root.$notify.show('Factura Impresa', { color: 'info' }) : null; })
            //   .catch(() => window.console.log('mutation failed'));
          });
          launchPrint();
        };

        d.print(el, styles, scripts, printCallback);
      },

      closeDialog() {
        this.dialog = false;
        this.recibo = null;
        this.matriz = null;
        this.sucursal = null;
        this.factura = null;
        this.nit = null;
        this.subtotal = 0.0;
        this.form = { nombre_cliente: null, nit_cliente: null, sucursal_id: null };
      },
    },
    mounted() {
      const [day, month, year] = new Date()
        .toLocaleString('es-US', {
          timeZone: 'America/La_Paz',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        })
        .split('/');
      this.today = `${year}-${month}-${day}`;
      // window.console.log('variable', this.today, this.today.substr(0, 7));
      this.cssText = `
      table {
    border-collapse: collapse;
    border-spacing: 0;
    font-size: x-small;
    width: 100%;
  }
  .table-border {
    border: 1px solid silver;
  }
  .w-35per {
    width: 35%;
  }
  .w-98per {
    width: 98%;
  }
  .w-38per {
    width: 38%;
  }
  .w-40per {
    width: 40%;
  }
  .w-20per {
    width: 20%;
  }
  .w-24per {
    width: 24%;
  }
  .w-23per {
    width: 23%;
  }
  .w-10per {
    width: 10%;
  }
  .x-small {
    font-size: x-small;
  }
  .text-center {
    text-align: center;
  }
  .align-v-center {
    vertical-align: center;
  }
  .font-weight-bold {
    font-weight: bold;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .w-100 {
    width: 100%;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }
  .mb-2 {
    margin-bottom: 0.7rem;
  }
  .item-th {
    font-weight: bold;
    align-items: left;
  }
  hr {
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
  .float-left {
    float: left !important;
  }
  .border-box {
    border: solid 1px #4d84c7c7;
    border-radius: 0.4em;
    box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
  }
  .recibo-number {
    font-weight: bold;
    color: #305077;
    /* font-size: 1.2rem; */
  }
  .img-height {
    height: 60px;
  }
  .px-2 {
    padding-left: 2em;
    padding-right: 2em;
  }
  .pa-2 {
    padding: 2em;
  }
  .mitad-solid {
    position: absolute;
    top: 50%;
  }
  .font-size-1 {
    font-size: 1rem;
  }
  .pl-1 {
    padding-left: 0.5em;
  }
  .watermark1 {
      width: 40%;
      position: absolute;
      top: 10%;
      left: 30%;
  }
  .watermark3 {
      width: 40%;
      position: absolute;
      top: 35%;
      left: 30%;
  }
  .watermark2 {
      width: 30%;
      position: absolute;
      top: 0px;
      right: 2px;
      opacity: 70%;
  }
    `;
    },
  };
  // DELETE FROM detalle_factura WHERE factura_id >5;
  // UPDATE pagos_inscripcion SET factura_id = null WHERE factura_id >5;
  // DELETE FROM facturas WHERE id >5;
</script>

<style scoped>
  table {
    border-collapse: collapse;
    border-spacing: 0;
    font-size: x-small;
    width: 100%;
  }
  .table-border {
    border: 1px solid silver;
  }
  .w-35per {
    width: 35%;
  }
  .w-98per {
    width: 98%;
  }
  .w-38per {
    width: 38%;
  }
  .w-40per {
    width: 40%;
  }
  .w-20per {
    width: 20%;
  }
  .w-24per {
    width: 24%;
  }
  .w-23per {
    width: 23%;
  }
  .w-10per {
    width: 10%;
  }
  .x-small {
    font-size: x-small;
  }
  .text-center {
    text-align: center;
  }
  .align-v-center {
    vertical-align: center;
  }
  .font-weight-bold {
    font-weight: bold;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .w-100 {
    width: 100%;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }
  .mb-2 {
    margin-bottom: 0.7rem;
  }
  .item-th {
    font-weight: bold;
    align-items: left;
  }
  hr {
    margin-bottom: 3rem;
    margin-top: 3rem;
  }
  .float-left {
    float: left !important;
  }
  .border-box {
    border: solid 1px #4d84c7c7;
    border-radius: 0.4em;
    box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3);
  }
  .recibo-number {
    font-weight: bold;
    color: #305077;
    /* font-size: 1.2rem; */
  }
  .img-height {
    height: 60px;
  }
  .px-2 {
    padding-left: 2em;
    padding-right: 2em;
  }
  .pa-2 {
    padding: 2em;
  }
  .pl-1 {
    padding-left: 0.5em;
  }
  .mitad-solid {
    position: absolute;
    top: 50%;
  }
  .font-size-1 {
    font-size: 1rem;
  }
  .watermark1 {
    width: 50%;
    position: absolute;
    top: 30%;
    left: 25%;
  }
  .watermark2 {
    display: none;
  }
</style>
